import { DataStore } from "shared_critical/store";
import { $srpList } from "./list";

// variables
let searchResultTotalCount,
    searchId,
    noResults,
    isSearchSaved,
    seoURL,
    hasLocation,
    replaceState;

const updateVariables = () => {
  searchResultTotalCount = DataStore.getData("searchResultTotalCount");
  searchId = DataStore.getData("searchId");
  noResults = DataStore.getData("noResults");
  isSearchSaved = DataStore.getData("isSearchSaved");
  updateHistoryVariables(DataStore.getData("pushShareableHistoryArguments"));
};

const updateHistoryVariables = ({seoURL: _seoURL, hasLocation: _hasLocation, replaceState: _replaceState}) => {
  // needed to avoid eslint errors with {hasLocation} = DataStore.getData('key') assignment
  seoURL = _seoURL;
  hasLocation = _hasLocation;
  replaceState = _replaceState;
};

// update variables following ajax
$srpList.on("search::updated", updateVariables);

export const updateVariable = (key, value) => {
  switch (key) {
  case "searchResultTotalCount":
    searchResultTotalCount = value;
    break;
  case "searchId":
    searchId = value;
    break;
  case "noResults":
    noResults = value;
    break;
  case "isSearchSaved":
    isSearchSaved = value;
    break;
  case "seoURL":
    seoURL = value;
    break;
  case "hasLocation":
    hasLocation = value;
    break;
  case "replaceState":
    replaceState   = value;
    break;
  }
};

export {
  searchResultTotalCount,
  searchId,
  noResults,
  isSearchSaved,
  seoURL,
  hasLocation,
  replaceState
}



// WEBPACK FOOTER //
// ./srp/views/search-results/variables.js